/* Loom Cup Builder — iOS-safe + audit P0-P2 fixes */

(function () {
  'use strict';

  function escapeHtml(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function escapeAttr(str) { return escapeHtml(str); }
  function uid() { return Math.random().toString(36).slice(2, 8); }
  function t(key, fallback) { return (window.LOOM_T && window.LOOM_T[key]) || fallback; }

  /* Swiss-French price format: 4 → "4.-", 4.5 → "4.50". Whole francs use the
     local convention with a dash for "no centimes" instead of ".00". */
  function formatCHF(price) {
    if (price == null || isNaN(price)) return '0.-';
    var n = Number(price);
    var fixed = n.toFixed(2);
    return fixed.indexOf('.00') === fixed.length - 3 ? n.toFixed(0) + '.-' : fixed;
  }

  function scoopSVG(flavor, gradId) {
    return '<svg viewBox="0 0 120 120" width="100%" height="100%"><defs><radialGradient id="' + gradId + '" cx="35%" cy="30%" r="70%"><stop offset="0%" stop-color="' + flavor.swirl + '" stop-opacity="0.95"/><stop offset="60%" stop-color="' + flavor.color + '"/><stop offset="100%" stop-color="' + flavor.color + '"/></radialGradient></defs><circle cx="60" cy="60" r="54" fill="url(#' + gradId + ')"/><path d="M 24 54 Q 42 28 60 30 Q 78 32 98 54" fill="none" stroke="' + flavor.swirl + '" stroke-width="3" stroke-linecap="round" opacity="0.5"/><path d="M 32 68 Q 50 48 72 48" fill="none" stroke="' + flavor.swirl + '" stroke-width="2.5" stroke-linecap="round" opacity="0.35"/><ellipse cx="44" cy="38" rx="15" ry="8" fill="#fff" opacity="0.45"/></svg>';
  }

  function logoLabelSVG(x, y, w, h) {
    var url = window.LOOM_LOGO_URL || '';
    return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="4" fill="#FFF2DA"/><image href="' + url + '" x="' + (x + 8) + '" y="' + (y + 5) + '" width="' + (w - 16) + '" height="' + (h - 10) + '" preserveAspectRatio="xMidYMid meet"/>';
  }

  function cupSVG(width) {
    width = width || 300;
    return '<svg viewBox="0 0 300 260" width="' + width + '" style="display:block"><defs><linearGradient id="cup-body" x1="0" x2="0" y1="0" y2="1"><stop offset="0" stop-color="#FFF2DA"/><stop offset="1" stop-color="#F3E3C4"/></linearGradient></defs><path d="M40 90 L260 90 L230 250 L70 250 Z" fill="url(#cup-body)" stroke="#432918" stroke-width="3"/>' + logoLabelSVG(70, 135, 160, 90) + '</svg>';
  }
  function cupFrontSVG(width) {
    width = width || 300;
    return '<svg viewBox="0 0 300 260" width="' + width + '" style="display:block;position:absolute;top:0;left:0;pointer-events:none"><defs><linearGradient id="cup-body-front" x1="0" x2="0" y1="0" y2="1"><stop offset="0" stop-color="#FFF2DA"/><stop offset="1" stop-color="#F3E3C4"/></linearGradient></defs><path d="M40 90 L260 90 L230 250 L70 250 Z" fill="url(#cup-body-front)" stroke="#432918" stroke-width="3" stroke-linejoin="round"/>' + logoLabelSVG(70, 135, 160, 90) + '</svg>';
  }
  function coneSVG(width) {
    width = width || 300;
    return '<svg viewBox="0 0 300 340" width="' + width + '" style="display:block"><defs><pattern id="waffle" patternUnits="userSpaceOnUse" width="16" height="16" patternTransform="rotate(45)"><rect width="16" height="16" fill="#C8924F"/><path d="M0 0 L16 0 M0 8 L16 8 M0 16 L16 16" stroke="#8A5A1F" stroke-width="1.2"/><path d="M0 0 L0 16 M8 0 L8 16 M16 0 L16 16" stroke="#8A5A1F" stroke-width="1.2"/></pattern></defs><ellipse cx="150" cy="70" rx="110" ry="16" fill="#D4A164" stroke="#432918" stroke-width="3"/><path d="M40 70 L260 70 L150 330 Z" fill="url(#waffle)" stroke="#432918" stroke-width="3"/><path d="M40 70 L260 70 L150 330 Z" fill="#432918" opacity="0.15"/><ellipse cx="150" cy="70" rx="100" ry="10" fill="#8A5A1F" opacity="0.6"/></svg>';
  }
  function coneFrontSVG(width) {
    width = width || 300;
    return '<svg viewBox="0 0 300 340" width="' + width + '" style="display:block;position:absolute;top:0;left:0;pointer-events:none"><defs><pattern id="waffle2" patternUnits="userSpaceOnUse" width="16" height="16" patternTransform="rotate(45)"><rect width="16" height="16" fill="#C8924F"/><path d="M0 0 L16 0 M0 8 L16 8 M0 16 L16 16" stroke="#8A5A1F" stroke-width="1.2"/><path d="M0 0 L0 16 M8 0 L8 16 M16 0 L16 16" stroke="#8A5A1F" stroke-width="1.2"/></pattern></defs><path d="M40 70 A110 16 0 0 1 260 70 L150 330 Z" fill="url(#waffle2)" stroke="#432918" stroke-width="3" stroke-linejoin="round"/><path d="M40 70 A110 16 0 0 1 260 70 L150 330 Z" fill="#432918" opacity="0.15"/><path d="M52 70 A98 10 0 0 0 248 70" fill="none" stroke="#5A3A10" stroke-width="1.5" opacity="0.5"/></svg>';
  }
  function tubSVG(width, capacity) {
    var cfg = window.LOOM_TUB_SIZES[capacity] || window.LOOM_TUB_SIZES[3];
    var w = cfg.w, h = cfg.h, rectW = cfg.rectW, rectH = cfg.rectH;
    var rectX = (w - rectW) / 2, rectY = cfg.rimY;
    var labelW = cfg.labelW, labelH = cfg.labelH;
    var labelX = (w - labelW) / 2, labelY = rectY + 35;
    return '<svg viewBox="0 0 ' + w + ' ' + h + '" width="' + (width || w) + '" style="display:block"><defs><linearGradient id="tub-body-' + capacity + '" x1="0" x2="0" y1="0" y2="1"><stop offset="0" stop-color="#FFF2DA"/><stop offset="1" stop-color="#EBD8AE"/></linearGradient></defs><rect x="' + rectX + '" y="' + rectY + '" width="' + rectW + '" height="' + rectH + '" rx="6" fill="url(#tub-body-' + capacity + ')" stroke="#432918" stroke-width="3"/>' + logoLabelSVG(labelX, labelY, labelW, labelH) + '</svg>';
  }
  function tubFrontSVG(width, capacity) {
    var cfg = window.LOOM_TUB_SIZES[capacity] || window.LOOM_TUB_SIZES[3];
    var w = cfg.w, h = cfg.h, rectW = cfg.rectW, rectH = cfg.rectH;
    var rectX = (w - rectW) / 2, rectY = cfg.rimY;
    var rectBottom = rectY + rectH;
    var labelW = cfg.labelW, labelH = cfg.labelH;
    var labelX = (w - labelW) / 2, labelY = rectY + 35;
    var pathD = 'M' + rectX + ' ' + rectY + ' L' + (rectX + rectW) + ' ' + rectY + ' L' + (rectX + rectW) + ' ' + (rectBottom - 6) + ' Q' + (rectX + rectW) + ' ' + rectBottom + ' ' + (rectX + rectW - 6) + ' ' + rectBottom + ' L' + (rectX + 6) + ' ' + rectBottom + ' Q' + rectX + ' ' + rectBottom + ' ' + rectX + ' ' + (rectBottom - 6) + ' Z';
    return '<svg viewBox="0 0 ' + w + ' ' + h + '" width="' + (width || w) + '" style="display:block;position:absolute;top:0;left:0;pointer-events:none"><defs><linearGradient id="tub-body-front-' + capacity + '" x1="0" x2="0" y1="0" y2="1"><stop offset="0" stop-color="#FFF2DA"/><stop offset="1" stop-color="#EBD8AE"/></linearGradient></defs><path d="' + pathD + '" fill="url(#tub-body-front-' + capacity + ')" stroke="#432918" stroke-width="3" stroke-linejoin="round"/>' + logoLabelSVG(labelX, labelY, labelW, labelH) + '</svg>';
  }

  function famIcon(kind) {
    if (kind === 'cornet')  return coneSVG(46);
    if (kind === 'gobelet') return cupSVG(50);
    return tubSVG(56, 3);
  }

  function scoopPos(i, vId) {
    var isBac    = vId && vId.indexOf('bac') === 0;
    var isCornet = vId && vId.indexOf('cornet') === 0;

    if (isBac) {
      var v = window.LOOM_VESSELS.find(function (x) { return x.id === vId; });
      var cap = (v && v.capacity) || 4;
      /* visualKey = grandezza visiva della vaschetta (S/M/L/XL = 3/4/5/6).
         cap = numero max di scoops (sempre 4 per i bac). Decoupling permette
         di avere bac più grandi visualmente con stesso numero di palline. */
      var visualKey = (v && v.volumeKey) || cap;
      var cfg = (window.LOOM_TUB_SIZES && window.LOOM_TUB_SIZES[visualKey]) || { w: 280, h: 220, rectW: 220, rimY: 60 };
      var wrapW = cfg.w, wrapH = cfg.h;
      var cx = wrapW / 2;
      var innerW = cfg.rectW - 24;
      var frontMax = Math.max(2, Math.min(cap, Math.round(innerW / 78)));
      var frontRow = Math.min(cap, frontMax);
      var backRow = cap - frontRow;
      /* size adattiva: con palla=110 le scoop esterne escono dai bordi della
         vaschetta (sia per L/XL 4-in-fila sia per S/M 3-in-fila). Riduco a 88
         per tutti i bac così tutte le palle restano dentro il contorno e la
         composizione appare visualmente centrata sulla vaschetta. */
      var size = 88;
      var rimCenterBottom = wrapH - cfg.rimY;
      var baseBottom = rimCenterBottom - size / 2 + 12;
      if (i < frontRow) {
        var slot = innerW / frontRow;
        var left = cx - innerW / 2 + slot * (i + 0.5);
        return { left: left, bottom: baseBottom, size: size };
      }
      var j = i - frontRow;
      var backSize = size - 10;
      var backInner = innerW - 30;
      var backSlot = backRow > 0 ? backInner / backRow : backInner;
      var leftB = cx - backInner / 2 + backSlot * (j + 0.5);
      return { left: leftB, bottom: baseBottom + size * 0.5, size: backSize };
    }
    if (isCornet) {
      var rcbC = 270, size0 = 130, b0 = rcbC - size0 / 2 + 18;
      if (i === 0) return { left: 150, bottom: b0, size: size0 };
      if (i === 1) return { left: 150, bottom: b0 + size0 * 0.55, size: 115 };
      if (i === 2) return { left: 128, bottom: b0 + size0 * 0.42, size: 108 };
      return            { left: 172, bottom: b0 + size0 * 0.42, size: 108 };
    }
    var rcbG = 170, fSize = 120, fBot = rcbG - fSize / 2 + 14;
    if (i === 0) return { left: 150, bottom: fBot + 18, size: fSize };
    if (i === 1) return { left: 100, bottom: fBot,      size: 110 };
    if (i === 2) return { left: 200, bottom: fBot,      size: 110 };
    if (i === 3) return { left: 128, bottom: fBot + 60, size: 105 };
    if (i === 4) return { left: 172, bottom: fBot + 60, size: 105 };
    return            { left: 150, bottom: fBot + 112, size: 98 };
  }

  function LoomCupBuilder(root, opts) {
    if (!(this instanceof LoomCupBuilder)) return new LoomCupBuilder(root, opts);
    this.root = root;
    this.layout = (opts && opts.layout) || 'tray';
    this.toastEl = null;
    this._searchT = null;

    // Mobile mode detection — at viewport ≤ 768px, render cup-as-sticky-hero with inline flavors.
    var mql = window.matchMedia ? window.matchMedia('(max-width: 768px)') : { matches: false, addListener: function(){}, addEventListener: function(){} };
    this._mql = mql;

    this.state = {
      mode: mql.matches ? 'mobile' : 'desktop',
      vesselFamily: 'gobelet',
      vesselId: 'petit',
      scoops: [],
      justAdded: null,
      catFilter: 'all',
      activeTag: null,
      query: '',
      showSurprise: false
    };

    var self = this;
    function onMqlChange(e) {
      self.setState({ mode: e.matches ? 'mobile' : 'desktop' });
    }
    if (mql.addEventListener) mql.addEventListener('change', onMqlChange);
    else if (mql.addListener) mql.addListener(onMqlChange);

    /* Mobile cup pinning — gestito via JS perché position:sticky è inaffidabile
       su iOS Safari (vari bug a seconda della versione + interazioni con altri
       CSS dell'app). Quando l'utente scrolla oltre la family/vessel picker, la
       coppa diventa position:fixed sotto la nav. Quando torna su, ridiventa
       inline nella sua posizione naturale. Vedi setupMobileCupPin(). */
    this._scrollRAF = null;
    this._pinUpdate = function () { self._scrollRAF = null; self.updateCupPin(); };
    this._scrollHandler = function () {
      if (self._scrollRAF) return;
      self._scrollRAF = window.requestAnimationFrame(self._pinUpdate);
    };
    window.addEventListener('scroll', this._scrollHandler, { passive: true });
    window.addEventListener('resize', this._scrollHandler, { passive: true });

    this.bindEvents();   // bind ONCE — never re-bind on render
    this.render();
  }

  /* Toggle .is-pinned sulla cb-mobile-cup quando l'utente scrolla oltre la
     family/vessel picker. Usa getBoundingClientRect (sempre relativo al viewport)
     così non importa dove sia il cup-builder nella pagina. */
  /* Move-to-body pinning. `position: fixed` su iOS Safari può fallire se un
     antenato del cup-builder ha `transform`, `filter`, o `will-change` (anche
     a livello di app/sezioni Shopify esterne). Per essere immuni a qualsiasi
     antenato problematico, quando la coppa va pinnata la MUOVIAMO fisicamente
     come figlio diretto di <body>. Da lì, position:fixed è garantito relativo
     al viewport. Quando l'utente scrolla su, la rimettiamo nella sua posizione
     originale dentro il cup-builder. */
  LoomCupBuilder.prototype.updateCupPin = function () {
    if (this.state.mode !== 'mobile') return;

    var presets = this.root.querySelector('.cb-mobile-presets');
    var cup     = this._pinnedCup || this.root.querySelector('.cb-mobile-cup');
    if (!presets || !cup) return;

    /* Pin a top:0 — direttamente sotto la URL bar del browser, senza gap.
       Quando l'utente scrolla giù la loom-nav del sito scorre via e la coppa
       si attacca al bordo superiore del viewport. */
    var shouldPin = presets.getBoundingClientRect().bottom <= 0;

    /* Quando l'utente scrolla oltre la fine della sezione cup-builder
       (es. arriva al blocco "Storia"), la coppa pinnata va nascosta:
       non ha senso vederla mentre si legge un altro contenuto. */
    var rootBottom = this.root.getBoundingClientRect().bottom;
    var pastSection = rootBottom <= 0;

    if (shouldPin && this._pinnedCup) {
      /* Già pinnata: toggle visibilità in base a pastSection */
      if (pastSection) cup.style.setProperty('display', 'none', 'important');
      else             cup.style.setProperty('display', 'block', 'important');
    }

    if (shouldPin && !this._pinnedCup) {
      /* Difensivo: alcuni temi/app Shopify mettono transform/filter/will-change
         su <html> o <body>. Anche con la coppa figlia di <body>, un transform
         su body stesso rompe position:fixed. Li azzeriamo e li ripristiniamo
         all'unpin. */
      var html = document.documentElement;
      var body = document.body;
      this._origHtmlTransform = html.style.transform;
      this._origBodyTransform = body.style.transform;
      this._origHtmlFilter    = html.style.filter;
      this._origBodyFilter    = body.style.filter;
      html.style.setProperty('transform', 'none', 'important');
      body.style.setProperty('transform', 'none', 'important');
      html.style.setProperty('filter',    'none', 'important');
      body.style.setProperty('filter',    'none', 'important');

      /* Salva posizione originale, crea spacer, sposta cup in body. */
      this._cupOrigParent = cup.parentNode;
      this._cupOrigNext   = cup.nextElementSibling;
      var cupH = cup.offsetHeight;

      var spacer = document.createElement('div');
      spacer.className = 'cb-mobile-cup-spacer';
      spacer.style.height = cupH + 'px';
      cup.parentNode.insertBefore(spacer, cup);
      this._cupSpacer = spacer;

      document.body.appendChild(cup);
      cup.classList.add('is-pinned');
      cup.classList.add('cb-mobile');   /* preserva styling mobile dei discendenti */

      /* Forza inline con !important via setProperty — vince contro qualsiasi CSS. */
      cup.style.setProperty('position', 'fixed', 'important');
      cup.style.setProperty('top',     '0', 'important');
      cup.style.setProperty('left',    '0',  'important');
      cup.style.setProperty('right',   '0',  'important');
      cup.style.setProperty('bottom',  'auto', 'important');
      cup.style.setProperty('margin',  '0',  'important');
      cup.style.setProperty('width',   'auto', 'important');
      cup.style.setProperty('max-width', 'none', 'important');
      cup.style.setProperty('z-index', '999999', 'important');
      cup.style.setProperty('transform', 'translateZ(0)', 'important');
      cup.style.setProperty('display', 'block', 'important');
      cup.style.setProperty('visibility', 'visible', 'important');
      cup.style.setProperty('opacity', '1', 'important');

      this._pinnedCup = cup;
    } else if (!shouldPin && this._pinnedCup) {
      /* Unpin: rimetti la coppa al suo posto originale. */
      cup.classList.remove('is-pinned');
      cup.classList.remove('cb-mobile');
      /* Cancella tutti gli inline applicati al pin */
      ['position','top','left','right','bottom','margin','width','max-width','z-index','transform','display','visibility','opacity','background','outline'].forEach(function (p) {
        cup.style.removeProperty(p);
      });

      /* Ripristina transform/filter originali su html/body */
      var html2 = document.documentElement, body2 = document.body;
      if (this._origHtmlTransform) html2.style.transform = this._origHtmlTransform; else html2.style.removeProperty('transform');
      if (this._origBodyTransform) body2.style.transform = this._origBodyTransform; else body2.style.removeProperty('transform');
      if (this._origHtmlFilter)    html2.style.filter    = this._origHtmlFilter;    else html2.style.removeProperty('filter');
      if (this._origBodyFilter)    body2.style.filter    = this._origBodyFilter;    else body2.style.removeProperty('filter');

      if (this._cupSpacer && this._cupSpacer.parentNode) {
        this._cupSpacer.parentNode.replaceChild(cup, this._cupSpacer);
      } else if (this._cupOrigParent) {
        if (this._cupOrigNext && this._cupOrigNext.parentNode === this._cupOrigParent) {
          this._cupOrigParent.insertBefore(cup, this._cupOrigNext);
        } else {
          this._cupOrigParent.appendChild(cup);
        }
      }
      this._cupSpacer = null;
      this._pinnedCup = null;
    }
  };

  /* Restore the cup back into the cup-builder root before any full re-render.
     Otherwise the new innerHTML would create a second cup while the moved one
     orphans in body. Called from render(). */
  LoomCupBuilder.prototype.restoreCupBeforeRender = function () {
    if (!this._pinnedCup) return;
    var cup = this._pinnedCup;
    cup.classList.remove('is-pinned');
    cup.classList.remove('cb-mobile');
    ['position','top','left','right','bottom','margin','width','max-width','z-index','transform'].forEach(function (p) {
      cup.style.removeProperty(p);
    });
    /* Ripristina html/body transform/filter */
    var html = document.documentElement, body = document.body;
    if (this._origHtmlTransform) html.style.transform = this._origHtmlTransform; else html.style.removeProperty('transform');
    if (this._origBodyTransform) body.style.transform = this._origBodyTransform; else body.style.removeProperty('transform');
    if (this._origHtmlFilter)    html.style.filter    = this._origHtmlFilter;    else html.style.removeProperty('filter');
    if (this._origBodyFilter)    body.style.filter    = this._origBodyFilter;    else body.style.removeProperty('filter');
    if (this._cupSpacer && this._cupSpacer.parentNode) {
      this._cupSpacer.parentNode.replaceChild(cup, this._cupSpacer);
    }
    this._cupSpacer = null;
    this._pinnedCup = null;
  };

  LoomCupBuilder.prototype.setState = function (patch) {
    for (var k in patch) this.state[k] = patch[k];
    this.render();
  };

  LoomCupBuilder.prototype.vessel = function () {
    var sid = this.state.vesselId;
    return window.LOOM_VESSELS.find(function (v) { return v.id === sid; }) || window.LOOM_VESSELS[4] || window.LOOM_VESSELS[0];
  };
  LoomCupBuilder.prototype.capacity = function () { var v = this.vessel(); return (v && v.capacity) || 3; };
  LoomCupBuilder.prototype.full = function () { return this.state.scoops.length >= this.capacity(); };

  LoomCupBuilder.prototype.pickFamily = function (fam) {
    var ids = window.LOOM_VESSEL_FAMILIES[fam];
    if (!ids || !ids.length) return;
    var next = ids[Math.min(1, ids.length - 1)];
    var nv = window.LOOM_VESSELS.find(function (v) { return v.id === next; });
    var nextCap = (nv && nv.capacity) || 3;
    var scoops = this.state.scoops.length > nextCap ? this.state.scoops.slice(0, nextCap) : this.state.scoops;
    this.setState({ vesselFamily: fam, vesselId: next, scoops: scoops });
  };
  LoomCupBuilder.prototype.pickVessel = function (id) {
    var v = window.LOOM_VESSELS.find(function (x) { return x.id === id; });
    if (!v) return;
    var scoops = this.state.scoops.length > v.capacity ? this.state.scoops.slice(0, v.capacity) : this.state.scoops;
    this.setState({ vesselId: id, scoops: scoops });
  };
  LoomCupBuilder.prototype.addFlavor = function (flavorId) {
    if (this.full()) {
      var sel = this.root.querySelector('.cb-vessel-wrap');
      if (sel) {
        sel.className += ' shake';
        setTimeout(function () { sel.className = sel.className.replace(' shake', ''); }, 400);
      }
      return;
    }
    var f = window.LOOM_FLAVORS.find(function (x) { return x.id === flavorId; });
    if (!f) return;
    if (f.available === false) return;   /* out-of-stock flavor — silently ignore */
    var u = uid();
    this.state.scoops = this.state.scoops.concat([{ flavor: f, uid: u }]);
    this.state.justAdded = u;
    this.syncScoops();   /* Section 5.2: scoped update, preserves scroll position */
    var self = this;
    setTimeout(function () { if (self.state.justAdded === u) self.state.justAdded = null; }, 500);
  };
  LoomCupBuilder.prototype.removeScoop = function (uid) {
    this.state.scoops = this.state.scoops.filter(function (s) { return s.uid !== uid; });
    this.syncScoops();
  };
  LoomCupBuilder.prototype.clearAll = function () {
    this.state.scoops = [];
    this.syncScoops();
  };
  LoomCupBuilder.prototype.applyTrio = function (ids) {
    var cap = this.capacity();
    var flavors = ids.map(function (id) { return window.LOOM_FLAVORS.find(function (f) { return f.id === id; }); }).filter(Boolean);
    var taken = flavors.slice(0, Math.min(flavors.length, cap)).map(function (f) { return { flavor: f, uid: uid() }; });
    /* showSurprise toggle DOES affect the surprise panel structure, so this
       branch still routes through setState/render. Trio application is a rare
       action — the slight scroll jump is acceptable here. */
    this.setState({ scoops: taken, showSurprise: false });
  };

  /* === syncScoops — the critical scope-the-update fix (Section 5.2) =========
     Updates ONLY the parts of the UI that depend on scoops state:
       1. the cup wrap (re-renders the scoops layer + empty hint)
       2. the count line (`n / cap parfums`)
       3. the scoop pills below the cup (desktop summary)
       4. the compact summary strip (mobile, when scrolled into is-compact)
       5. the order-bar price + Commander disabled state
       6. the flavor tiles' disabled state (when full)
     It does NOT touch the flavor grid, filters, or the surprise panel. The
     scroll position of the page is preserved because none of those nodes are
     destroyed → Erika's "ti riporta sopra" bug is structurally fixed. */
  LoomCupBuilder.prototype.syncScoops = function () {
    var n = this.state.scoops.length;
    var cap = this.capacity();
    var full = this.full();
    var v = this.vessel();

    /* Quando la coppa è pinnata (mobile) è stata spostata sotto <body>, quindi
       non è più dentro this.root. Cerchiamo wrap/status/pills sia dentro la
       coppa pinnata sia dentro root. */
    var pinned = this._pinnedCup;

    // 1. Cup wrap — outerHTML swap preserves siblings (filters, grid) intact.
    var wrap = (pinned && pinned.querySelector('.cb-vessel-wrap')) || this.root.querySelector('.cb-vessel-wrap');
    if (wrap) {
      var tmp = document.createElement('div');
      tmp.innerHTML = this.htmlVesselWrap();
      var fresh = tmp.firstElementChild;
      if (fresh) wrap.parentNode.replaceChild(fresh, wrap);
    }

    // 2. Count line — desktop has .cb-status > .cb-count; mobile has .cb-status containing inline text + clear button.
    var statusEl = (pinned && pinned.querySelector('.cb-status')) || this.root.querySelector('.cb-status');
    if (statusEl) {
      var fullBadge = full ? ' · <span class="full-badge">' + t('complete', 'complet') + '</span>' : '';
      var clearLink = n > 0 ? ' · <button type="button" class="cb-clear" data-action="clear">' + t('removeAll', 'tout retirer') + '</button>' : '';
      // Detect mobile inline-status vs desktop cb-count nested pattern.
      var countNested = statusEl.querySelector('.cb-count');
      if (countNested) {
        countNested.innerHTML = n + ' / ' + cap + ' ' + (n === 1 ? 'parfum' : 'parfums') + fullBadge;
        var clearOld = statusEl.querySelector('.cb-clear');
        if (clearOld && n === 0) clearOld.remove();
        else if (!clearOld && n > 0) {
          var holder = document.createElement('template');
          holder.innerHTML = '<button type="button" class="cb-clear mono" data-action="clear">' + t('removeAll', 'tout retirer') + '</button>';
          statusEl.appendChild(holder.content.firstElementChild);
        }
      } else {
        statusEl.innerHTML = n + ' / ' + cap + ' ' + (n === 1 ? 'parfum' : 'parfums') + fullBadge + clearLink;
      }
    }

    // 3. Scoop pills — both htmlStage and htmlMobile always emit a .cb-scoop-pills
    //    wrapper (with [hidden] when empty) so we can simply swap them here.
    //    Le pills possono essere sia dentro la coppa pinnata sia dentro root.
    var pillsContainers = [].slice.call(this.root.querySelectorAll('.cb-scoop-pills'));
    if (pinned) {
      pillsContainers = pillsContainers.concat([].slice.call(pinned.querySelectorAll('.cb-scoop-pills')));
    }
    pillsContainers.forEach(function (el) {
      var t = document.createElement('div');
      t.innerHTML = this.htmlScoopPills();
      var fresh = t.firstElementChild;
      if (fresh) el.parentNode.replaceChild(fresh, el);
    }, this);

    // 4. Desktop .cb-summary — refresh its inner ("votre création" label + pills).
    var summary = this.root.querySelector('.cb-summary');
    if (summary) summary.innerHTML = this.htmlSummaryInner();

    // 5. Order bar — price text + Commander disabled state.
    var priceEl = this.root.querySelector('.cb-price');
    if (priceEl && v) priceEl.textContent = 'CHF ' + formatCHF(v.price);
    var orderBtn = this.root.querySelector('[data-action="order"]');
    if (orderBtn) orderBtn.disabled = n === 0;

    // Update the cb-order-left count line on the mobile order bar (it includes "n/cap").
    var orderLeftMono = this.root.querySelector('.cb-order-bar-mobile .cb-order-left .mono');
    if (orderLeftMono && v) {
      orderLeftMono.textContent = (v.label || '') + ' · ' + n + '/' + cap;
    }

    // 6. Flavor tiles disabled state — toggle WITHOUT re-rendering the grid.
    this.root.querySelectorAll('.cb-flavor-tile').forEach(function (tile) {
      tile.disabled = full;
    });
  };
  /* ========================================================================= */
  LoomCupBuilder.prototype.filteredFlavors = function () {
    var s = this.state, list = window.LOOM_FLAVORS;
    if (s.catFilter !== 'all') list = list.filter(function (f) { return f.cat === s.catFilter; });
    if (s.activeTag) list = list.filter(function (f) { return f.tags && f.tags.indexOf(s.activeTag) !== -1; });
    if (s.query.replace(/^\s+|\s+$/g, '')) {
      var q = s.query.toLowerCase();
      list = list.filter(function (f) { return f.fr.toLowerCase().indexOf(q) !== -1 || (f.note || '').toLowerCase().indexOf(q) !== -1; });
    }
    return list;
  };
  LoomCupBuilder.prototype.pairingIds = function () {
    if (this.state.scoops.length === 0) return {};
    var last = this.state.scoops[this.state.scoops.length - 1].flavor.id;
    var arr = (window.LOOM_PAIRINGS && window.LOOM_PAIRINGS[last]) || [];
    var set = {};
    for (var i = 0; i < arr.length; i++) set[arr[i]] = true;
    return set;
  };

  LoomCupBuilder.prototype.htmlFamilyPicker = function () {
    var fam = this.state.vesselFamily;
    /* Cornet temporarily removed from picker (production not ready). Only
       Gobelet (cup) and Bac (tub) shown. The cornet products in Shopify still
       exist; they're just not user-selectable.
       NB: la sotto-label coi conteggi parfums è stata rimossa — il "max N parfums"
       per-format vive ora sotto ogni vessel-button (vedi htmlVesselSwitch). */
    var fams = [
      { id: 'gobelet', fr: 'Gobelet' },
      { id: 'bac',     fr: 'Bac' }
    ];
    return '<div class="cb-family-picker" role="tablist">' + fams.map(function (f) {
      var active = fam === f.id ? ' active' : '';
      return '<button type="button" class="fam-btn' + active + '" data-action="pick-family" data-fam="' + f.id + '"><span class="fam-icon">' + famIcon(f.id) + '</span><span class="fam-text"><span class="fam-name">' + f.fr + '</span></span></button>';
    }).join('') + '</div>';
  };

  /* Vessel switch: nome + prezzo + "max N parfums" + (bac) "X personnes · N ml".
     Le info sono tutte sul bottone così il cliente vede a colpo d'occhio differenze
     di prezzo + capacità + porzioni tra le diverse taglie. */
  LoomCupBuilder.prototype.htmlVesselSwitch = function () {
    var familyIds = window.LOOM_VESSEL_FAMILIES[this.state.vesselFamily] || [];
    var current = this.state.vesselId;
    return '<div class="cb-vessel-switch" role="tablist">' + familyIds.map(function (id) {
      var v = window.LOOM_VESSELS.find(function (x) { return x.id === id; });
      if (!v) return '';
      var active = id === current ? ' active' : '';
      var cap = (v.capacity || 1);
      /* Range label: "1 parfum" se capacità 1, altrimenti "1–N parfums" */
      var maxLabel = cap === 1 ? '1 parfum' : '1–' + cap + ' parfums';
      /* Per i bac mostriamo anche "X personnes · N ml" sotto il "1–N parfums".
         I gobelet sono porzioni individuali, non serve. */
      var servingHtml = '';
      if (v.persons && v.ml) {
        servingHtml = '<span class="vs-serv">' + v.persons + ' pers · ' + v.ml + ' ml</span>';
      }
      return '<button type="button" class="vs-btn' + active + '" data-action="pick-vessel" data-id="' + id + '">' +
        '<span class="vs-row">' +
          '<span class="vs-name">' + v.short + '</span>' +
          '<span class="vs-cap">CHF&nbsp;' + formatCHF(v.price) + '</span>' +
        '</span>' +
        '<span class="vs-max">' + maxLabel + '</span>' +
        servingHtml +
      '</button>';
    }).join('') + '</div>';
  };

  /* P0-1 — vessel wrap uses --cb-vessel-w + --cb-vessel-h CSS variables so mobile
     CSS can override sizing without touching this helper. The reserved height
     (--cb-vessel-h) used to be a flat vesselH + 180 which left ~100–180px of
     dead vertical space above every cup. Now scoopHeadroom() returns a tight
     value per family so the wrap shrinks-to-fit the scoop stack. */
  function scoopHeadroom(isCornet, isBac) {
    if (isCornet) return 110;  /* up to 2–3 scoops stack diagonally above the cone */
    if (isBac)    return 70;   /* scoops sit mostly inside the tub; minimal top room */
    return 140;                /* gobelet — up to 3 scoops can stack above the cup */
  }

  LoomCupBuilder.prototype.htmlVesselWrap = function () {
    var vId = this.state.vesselId;
    var isCornet = vId.indexOf('cornet') === 0;
    var isBac    = vId.indexOf('bac') === 0;
    var cap      = this.capacity();
    var v        = this.vessel();
    /* visualKey = LOOM_TUB_SIZES key (3/4/5/6) per la dimensione del bac.
       cap = MAX scoops (4 per tutti i bac). Disaccoppia visuale da capacità. */
    var visualKey = (v && v.volumeKey) || cap;
    var bacCfg   = isBac && window.LOOM_TUB_SIZES[visualKey];
    var vesselW  = isBac ? (bacCfg ? bacCfg.w : 340) : 300;
    var vesselH  = isCornet ? 340 : (isBac ? (bacCfg ? bacCfg.h : 240) : 260);
    var wrapH    = vesselH + scoopHeadroom(isCornet, isBac);

    var self = this;
    var scoopsHtml = this.state.scoops.map(function (s, i) {
      var p = scoopPos(i, vId);
      var pop = (s.uid === self.state.justAdded) ? ' pop-in' : '';
      var gradId = 'g-' + s.flavor.id + '-' + s.uid + '-' + i;
      return '<button type="button" class="cb-scoop-btn' + pop + '" style="left:' + (p.left - p.size / 2) + 'px;bottom:' + p.bottom + 'px;width:' + p.size + 'px;height:' + p.size + 'px;z-index:' + (10 + i) + ';" data-action="remove-scoop" data-uid="' + s.uid + '"><div class="loom-scoop">' + scoopSVG(s.flavor, gradId) + '</div><span class="cb-scoop-x">×</span><span class="cb-scoop-label mono">' + escapeHtml(s.flavor.fr) + '</span></button>';
    }).join('');

    var vesselSvg = isCornet ? coneSVG(vesselW) : (isBac ? tubSVG(vesselW, visualKey) : cupSVG(vesselW));
    var vesselFrontSvg = isCornet ? coneFrontSVG(vesselW) : (isBac ? tubFrontSVG(vesselW, visualKey) : cupFrontSVG(vesselW));
    var emptyHint = this.state.scoops.length === 0 ? '<div class="cb-empty-hint"><span class="mono">↓ ' + t('chooseFlavor', 'choisissez un parfum') + '</span></div>' : '';

    return '<div class="cb-vessel-wrap" style="--cb-vessel-w:' + vesselW + 'px;--cb-vessel-h:' + wrapH + 'px;width:var(--cb-vessel-w);height:var(--cb-vessel-h)"><div class="cb-scoops" style="width:' + vesselW + 'px;height:' + wrapH + 'px">' + scoopsHtml + '</div><div class="cb-vessel">' + vesselSvg + '</div>' + emptyHint + '<div class="cb-vessel-front" style="width:' + vesselW + 'px;height:' + vesselH + 'px">' + vesselFrontSvg + '</div></div>';
  };

  LoomCupBuilder.prototype.htmlStage = function () {
    var v = this.vessel();
    var n = this.state.scoops.length;
    /* Always emit .cb-summary so syncScoops can target it on the first scoop
       add (no need for fallback DOM insertion). Inner is empty when n === 0. */
    var summary = '<div class="cb-summary">' + this.htmlSummaryInner() + '</div>';
    /* NR-5: pairing hint moves under the cup on desktop (was at top of tray). */
    var pairingHint = this.htmlPairingHint();
    return '<div class="cb-stage">' + this.htmlFamilyPicker() + this.htmlVesselSwitch() + this.htmlVesselWrap() + this.htmlCount() + pairingHint + summary + '<div class="cb-order-bar"><div class="cb-order-left"><div class="mono" style="opacity:.6;font-size:9px">' + escapeHtml(v ? v.label : '') + '</div><div class="display cb-price">CHF ' + (v ? formatCHF(v.price) : '0.-') + '</div></div><button type="button" class="btn solid" data-action="order"' + (n === 0 ? ' disabled' : '') + '>' + t('order', 'Commander') + '</button></div></div>';
  };

  LoomCupBuilder.prototype.htmlSurprisePanel = function () {
    if (!this.state.showSurprise) return '';
    var trios = window.LOOM_TRIOS || [];
    return '<div class="cb-surprise-panel"><div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px"><span class="mono">' + t('signatureTrios', 'Trios signature du glacier') + '</span><button type="button" class="cb-clear mono" data-action="close-surprise">' + t('close', 'fermer') + '</button></div><div class="cb-trio-grid">' + trios.map(function (trio) {
      /* NR-4: show the trio's flavors as readable names so the user can see
         what they're applying before tapping. Resolve each id → human name. */
      var flavorObjs = trio.ids.map(function (id) {
        return window.LOOM_FLAVORS.find(function (x) { return x.id === id; });
      }).filter(Boolean);
      var dots = flavorObjs.map(function (f, i) {
        return '<span class="cb-trio-dot" style="background:' + f.color + ';border-color:' + f.ink + ';z-index:' + (3 - i) + '"></span>';
      }).join('');
      var flavorNames = flavorObjs.map(function (f) { return escapeHtml(f.fr); }).join(' · ');
      return '<button type="button" class="cb-trio-card" data-action="apply-trio" data-ids="' + escapeAttr(trio.ids.join(',')) + '"><div class="cb-trio-scoops">' + dots + '</div><div class="cb-trio-name editorial">' + escapeHtml(trio.name) + '</div><div class="cb-trio-flavors editorial">' + flavorNames + '</div><div class="cb-trio-tag mono">' + escapeHtml(trio.tag) + '</div></button>';
    }).join('') + '</div></div>';
  };

  /* NR-5: the "ça va bien avec X" hint extracted into its own helper. On
     mobile (Model B) it sits at the top of the scrolling tray, right under
     the sticky cup. On desktop it moves under the cup — see htmlStage. */
  LoomCupBuilder.prototype.htmlPairingHint = function () {
    var s = this.state;
    if (s.scoops.length === 0 || s.query || s.activeTag) return '';
    var pairings = this.pairingIds();
    var hasPairing = false;
    for (var k in pairings) { if (pairings[k]) { hasPairing = true; break; } }
    if (!hasPairing) return '';
    var last = s.scoops[s.scoops.length - 1].flavor.fr;
    return '<div class="cb-pairing-hint mono">✦ ' + t('pairsWith', 'ça va bien avec') + ' <em>' + escapeHtml(last) + '</em></div>';
  };

  /* P2-3 — search input gets iOS keyboard hints to skip autocorrect/autocapitalize */
  /* Filter controls (search + tabs + chips + counts) — sticky on mobile, top of tray on desktop.
     pairingHint is NOT included here anymore (NR-5) — desktop pulls it via
     htmlStage so it sits next to the cup; mobile injects it just above the
     grid via htmlTrayInner. */
  LoomCupBuilder.prototype.htmlTrayFilters = function () {
    var s = this.state;
    var filtered = this.filteredFlavors();
    var clearSearch = s.query ? '<button type="button" class="cb-search-clear" data-action="clear-search" aria-label="Clear">×</button>' : '';
    var pairingHint = this.state.mode === 'mobile' ? this.htmlPairingHint() : '';
    var resetBtn = (s.activeTag || s.query || s.catFilter !== 'all') ? '<button type="button" class="cb-clear mono" data-action="reset-filters" style="margin-left:12px">' + t('reset', 'réinitialiser') + '</button>' : '';
    var cats = [
      { id: 'all',    label: t('all', 'Tous'),       count: window.LOOM_FLAVORS.length },
      { id: 'glace',  label: t('glaces', 'Glaces'),  count: window.LOOM_FLAVORS.filter(function (f) { return f.cat === 'glace'; }).length },
      { id: 'sorbet', label: t('sorbets', 'Sorbets'), count: window.LOOM_FLAVORS.filter(function (f) { return f.cat === 'sorbet'; }).length }
    ];
    var catTabsHtml = '<div class="cb-cat-tabs">' + cats.map(function (c) {
      var active = s.catFilter === c.id ? ' active' : '';
      return '<button type="button" class="cb-cat-tab' + active + '" data-action="set-cat" data-cat="' + c.id + '">' + c.label + ' <span class="cb-cat-count">' + c.count + '</span></button>';
    }).join('') + '</div>';
    var chipsHtml = '<div class="cb-chips">' + (window.LOOM_TAGS || []).map(function (tag) {
      var active = s.activeTag === tag.id ? ' active' : '';
      return '<button type="button" class="cb-chip' + active + '" data-action="toggle-tag" data-tag="' + escapeAttr(tag.id) + '">' + escapeHtml(tag.label) + '</button>';
    }).join('') + '</div>';
    return '<div class="cb-tray-top"><div class="cb-search"><span class="cb-search-icon">⌕</span><input id="loom-cb-search" type="search" inputmode="search" autocomplete="off" autocorrect="off" autocapitalize="off" enterkeyhint="search" spellcheck="false" placeholder="' + escapeAttr(t('search', 'chercher un parfum…')) + '" value="' + escapeAttr(s.query) + '">' + clearSearch + '</div><button type="button" class="cb-surprise" data-action="toggle-surprise"><span class="pattern">wow</span><span class="mono">' + t('surpriseMe', 'Surprenez-moi') + '</span></button></div>' + this.htmlSurprisePanel() + catTabsHtml + chipsHtml + pairingHint + '<div class="cb-results-count mono">' + filtered.length + ' ' + (filtered.length === 1 ? 'parfum' : 'parfums') + resetBtn + '</div>';
  };

  /* Flavor grid — the only thing that scrolls on mobile when filters are sticky. */
  LoomCupBuilder.prototype.htmlFlavorGrid = function () {
    var pairings = this.pairingIds();
    var filtered = this.filteredFlavors();
    var self = this;
    var tilesHtml = filtered.length === 0
      ? '<div class="cb-empty-results editorial">' + t('noFlavor', 'Aucun parfum.') + ' <button type="button" class="cb-clear mono" data-action="reset-filters">' + t('seeAll', 'voir tout') + '</button></div>'
      : filtered.map(function (f) {
          var paired = !!pairings[f.id];
          /* Out-of-stock flavors (managed via Shopify metaobject / shop metafield)
             render greyed-out and non-clickable. Same tile, different state — so
             the customer sees that the flavor exists but isn't available today. */
          var off = f.available === false;
          var isDisabled = off || self.full();
          var disabled = isDisabled ? ' disabled' : '';
          var stateClass = (paired ? ' paired' : '') + (off ? ' is-unavailable' : '');
          var pairBadge = paired && !off ? '<span class="cb-pair-badge">✦</span>' : '';
          /* NR-2: show category on EVERY tile (was sorbet only) so you can tell
             glace vs sorbet at a glance without applying a filter. */
          var catLabel = f.cat === 'sorbet' ? 'sorbet' : 'glace';
          var catBadge = '<span class="cb-cat-badge cb-cat-badge--' + f.cat + ' mono">' + catLabel + '</span>';
          var unavBadge = off ? '<span class="cb-unav-badge mono">' + t('unavailable', 'indisponible') + '</span>' : '';
          /* NR-8 structure: render allergens if present. Empty by default; team
             will populate via Shopify metafield (`flavor.allergens`) or directly
             in loom-data.js. */
          var allergens = (f.allergens && f.allergens.length)
            ? '<div class="cb-flavor-allergens mono">⚠ ' + f.allergens.map(escapeHtml).join(' · ') + '</div>'
            : '';
          return '<button type="button" class="cb-flavor-tile' + stateClass + '" style="--tile-bg:' + f.color + ';--tile-ink:' + f.ink + ';background:' + f.color + ';color:' + f.ink + '" data-action="add-flavor" data-flavor="' + f.id + '"' + disabled + '><div class="cb-flavor-dot">' + scoopSVG(f, 'g-' + f.id + '-tile') + '</div><div class="cb-flavor-meta"><div class="cb-flavor-name editorial">' + escapeHtml(f.fr) + '</div><div class="cb-flavor-note mono">' + escapeHtml(f.note || '') + '</div>' + allergens + '</div>' + pairBadge + catBadge + unavBadge + '<div class="cb-flavor-plus">＋</div></button>';
        }).join('');
    return '<div class="cb-flavor-grid grid-' + this.layout + '">' + tilesHtml + '</div>';
  };

  LoomCupBuilder.prototype.htmlTrayInner = function () {
    return this.htmlTrayFilters() + this.htmlFlavorGrid();
  };
  LoomCupBuilder.prototype.htmlTray = function () {
    return '<div class="cb-tray">' + this.htmlTrayInner() + '</div>';
  };

  LoomCupBuilder.prototype.html = function () {
    return this.state.mode === 'mobile' ? this.htmlMobile() : this.htmlDesktop();
  };

  LoomCupBuilder.prototype.htmlDesktop = function () {
    return '<div class="cup-builder layout-' + this.layout + '">' + this.htmlStage() + this.htmlTray() + '</div>';
  };

  /* === Model B (Section 5) — mobile redesign ================================
     Four blocks stacked vertically:
       1. cb-mobile-presets — family picker + vessel switch. Scrolls away
          normally (the user touches it once at the start of the session).
       2. cb-mobile-cup — STICKY. Compact ~140px cup + count + tout-retirer +
          scoop pills. Pinned just below the .loom-nav so the user always sees
          the cup fill while picking flavors below.
       3. cb-mobile-tray — filters (search, surprise, cat tabs, chips, pairing
          hint) followed by the flavor grid. The ONLY scrolling region — no
          inner overflow, part of the page scroll (kills the iOS scroll-trap).
       4. cb-order-bar-mobile — fixed bottom (P0-4).
     Replaces the previous hybrid which had a full cup that toggled to a
     compact strip on scroll. Model B keeps the cup compact ALWAYS so there's
     no state change, no scroll-driven mode toggle, no peek cup mode. */
  LoomCupBuilder.prototype.htmlMobile = function () {
    return (
      '<div class="cup-builder cb-mobile">' +
        '<div class="cb-mobile-presets">' +
          this.htmlFamilyPicker() +
          this.htmlVesselSwitch() +
        '</div>' +
        '<div class="cb-mobile-cup">' +
          this.htmlVesselWrap() +
          this.htmlCount() +
          this.htmlScoopPills() +  /* always emit (hidden when empty) — see Section 5.2 syncScoops */
        '</div>' +
        '<div class="cb-mobile-tray">' + this.htmlTrayInner() + '</div>' +
        this.htmlOrderBarMobile() +
      '</div>'
    );
  };

  /* Extracted in Section 5.6 step 1 — used by both desktop htmlStage and the
     Model B mobile cup band. Returns the "n / cap parfums + tout retirer"
     line. syncScoops() also targets this so the counter updates without a
     full re-render. */
  LoomCupBuilder.prototype.htmlCount = function () {
    var n = this.state.scoops.length;
    var cap = this.capacity();
    var full = this.full();
    var fullBadge = full ? ' · <span class="full-badge">' + t('complete', 'complet') + '</span>' : '';
    var clearLink = n > 0 ? ' <button type="button" class="cb-clear mono" data-action="clear">' + t('removeAll', 'tout retirer') + '</button>' : '';
    return (
      '<div class="cb-status mono">' +
        '<span class="cb-count">' + n + ' / ' + cap + ' ' + (n === 1 ? 'parfum' : 'parfums') + fullBadge + '</span>' +
        clearLink +
      '</div>'
    );
  };

  LoomCupBuilder.prototype.htmlSummaryLine = function () {
    var names = this.state.scoops.map(function (s) { return s.flavor.fr; }).join(' · ');
    return '<div class="cb-summary editorial cb-summary-text">' + escapeHtml(names) + '</div>';
  };

  /* Removable scoop pills — the PRIMARY remove UI on both desktop and mobile.
     The × on the scoop itself is fragile (iOS hit-test issues with the cup-front
     overlay), so each chosen flavor renders below the cup as a colored pill that
     reliably removes on tap.
     Always emits the wrapper (even when empty) so syncScoops always has a swap
     target. The `hidden` attribute on the empty-state element keeps it out of
     layout and out of the a11y tree. */
  LoomCupBuilder.prototype.htmlScoopPills = function () {
    if (this.state.scoops.length === 0) return '<div class="cb-scoop-pills" hidden></div>';
    var pills = this.state.scoops.map(function (s) {
      return (
        '<button type="button" class="cb-scoop-pill"' +
          ' data-action="remove-scoop" data-uid="' + s.uid + '"' +
          ' style="background:' + s.flavor.color + ';color:' + s.flavor.ink + ';border-color:' + s.flavor.ink + '"' +
          ' aria-label="' + escapeAttr(t('removeScoop', 'Retirer') + ' ' + s.flavor.fr) + '">' +
          '<span class="cb-scoop-pill-name editorial">' + escapeHtml(s.flavor.fr) + '</span>' +
          '<span class="cb-scoop-pill-x" aria-hidden="true">×</span>' +
        '</button>'
      );
    }).join('');
    return '<div class="cb-scoop-pills">' + pills + '</div>';
  };

  /* Desktop summary block — label + pills together. Always emitted so the
     cb-summary container exists from first render and syncScoops only needs
     to swap innerHTML. Returns empty inner when no scoops. */
  LoomCupBuilder.prototype.htmlSummaryInner = function () {
    if (this.state.scoops.length === 0) return '';
    return (
      '<div class="mono" style="opacity:.6;margin-bottom:8px">' + t('yourCreation', 'votre création') + '</div>' +
      this.htmlScoopPills()
    );
  };

  /* (Model B Section 5.5: removed htmlMobileSummary / .cb-compact-summary —
     the always-compact sticky cup makes the scroll-replacement strip unnecessary.
     The cb-scoop-pills rendered inside .cb-mobile-cup are now the always-visible
     summary on mobile, identical to the desktop summary.) */

  LoomCupBuilder.prototype.htmlOrderBarMobile = function () {
    var v = this.vessel();
    var n = this.state.scoops.length;
    return (
      '<div class="cb-order-bar cb-order-bar-mobile">' +
        '<div class="cb-order-left">' +
          '<div class="mono" style="opacity:.6;font-size:9px">' + escapeHtml(v ? v.label : '') + ' · ' + n + '/' + this.capacity() + '</div>' +
          '<div class="display cb-price">CHF ' + (v ? formatCHF(v.price) : '0.-') + '</div>' +
        '</div>' +
        '<button type="button" class="btn solid" data-action="order"' + (n === 0 ? ' disabled' : '') + '>' +
          t('order', 'Commander') +
        '</button>' +
      '</div>'
    );
  };

  LoomCupBuilder.prototype.render = function () {
    var active = document.activeElement;
    var activeId = active && active.id;
    var selStart, selEnd;
    if (active && active.tagName === 'INPUT') {
      try { selStart = active.selectionStart; selEnd = active.selectionEnd; } catch (e) {}
    }
    /* Section 5.2 — scoop mutations route through syncScoops() and never call
       render(), so they preserve scroll naturally. For state changes that DO
       still call render() (filter chips, surprise toggle, vessel switch), save
       and restore window.scrollY so the page doesn't bounce. */
    var scrollY = (window.scrollY != null) ? window.scrollY : (window.pageYOffset || 0);
    /* Se la coppa è stata spostata sotto <body> (pin nucleare), va rimessa
       a posto PRIMA di distruggere root.innerHTML — altrimenti il nuovo HTML
       crea una seconda coppa e quella spostata resta orfana nel body. */
    if (this.restoreCupBeforeRender) this.restoreCupBeforeRender();
    this.root.innerHTML = this.html();
    if (activeId) {
      var el = this.root.querySelector('#' + activeId);
      if (el) {
        el.focus();
        if (selStart != null && el.setSelectionRange) {
          try { el.setSelectionRange(selStart, selEnd != null ? selEnd : selStart); } catch (e) {}
        }
      }
    }
    if (scrollY > 0) {
      try { window.scrollTo(0, scrollY); } catch (e) {}
    }
    /* Re-evaluate cup pinning dopo il re-render (la struttura DOM è cambiata,
       potrebbe servire pin/unpin in base alla scroll position attuale). */
    if (this.updateCupPin) this.updateCupPin();
  };

  /* P2-5 — debounce search input to avoid jank on slow iPhones
     Listener su document (non su this.root): quando la coppa viene spostata
     come figlio diretto di <body> per il pin, i click NON bubblano fino al
     root del cup-builder. Catturiamo a document e filtriamo per inclusione
     in self.root OPPURE in self._pinnedCup. */
  LoomCupBuilder.prototype.bindEvents = function () {
    var self = this;
    document.addEventListener('click', function (e) {
      var btn = e.target;
      while (btn && btn !== document && !(btn.getAttribute && btn.getAttribute('data-action'))) {
        btn = btn.parentNode;
      }
      if (!btn || btn === document || !btn.getAttribute) return;
      var inRoot   = self.root && self.root.contains(btn);
      var inPinned = self._pinnedCup && self._pinnedCup.contains(btn);
      if (!inRoot && !inPinned) return;
      var action = btn.getAttribute('data-action');
      switch (action) {
        case 'pick-family':   return self.pickFamily(btn.getAttribute('data-fam'));
        case 'pick-vessel':   return self.pickVessel(btn.getAttribute('data-id'));
        case 'add-flavor':    return self.addFlavor(btn.getAttribute('data-flavor'));
        case 'remove-scoop':  return self.removeScoop(btn.getAttribute('data-uid'));
        case 'clear':         return self.clearAll();
        case 'set-cat':       return self.setState({ catFilter: btn.getAttribute('data-cat') });
        case 'toggle-tag':
          var tg = btn.getAttribute('data-tag');
          return self.setState({ activeTag: self.state.activeTag === tg ? null : tg });
        case 'clear-search':  return self.setState({ query: '' });
        case 'reset-filters': return self.setState({ activeTag: null, query: '', catFilter: 'all' });
        case 'toggle-surprise': return self.setState({ showSurprise: !self.state.showSurprise });
        case 'close-surprise':  return self.setState({ showSurprise: false });
        case 'apply-trio':    return self.applyTrio(btn.getAttribute('data-ids').split(','));
        case 'order':         return self.handleOrder(btn);
        case 'scroll-top':
          try { window.scrollTo({ top: 0, behavior: 'smooth' }); }
          catch (e) { window.scrollTo(0, 0); }
          return;
      }
    });
    /* Event delegation per input. Anche qui document-level per coerenza
       (e perché il render() potrebbe spostare l'input in futuro). */
    document.addEventListener('input', function (e) {
      if (!e.target || e.target.id !== 'loom-cb-search') return;
      var inRoot   = self.root && self.root.contains(e.target);
      var inPinned = self._pinnedCup && self._pinnedCup.contains(e.target);
      if (!inRoot && !inPinned) return;
      self.state.query = e.target.value;
      if (self._searchT) clearTimeout(self._searchT);
      self._searchT = setTimeout(function () { self.render(); }, 120);
    });
  };

  LoomCupBuilder.prototype.handleOrder = function (btn) {
    var self = this;
    if (this.state.scoops.length === 0) return;
    var v = this.vessel();
    var variants = window.LOOM_VESSEL_VARIANTS || {};
    var variantId = variants[v.id];
    if (!variantId) {
      this.toast(t('noVariantError', 'Produit introuvable. Importez le CSV produits dans Shopify.'), true);
      return;
    }
    var properties = {
      'Format': v.label,
      'Parfums': this.state.scoops.map(function (s) { return s.flavor.fr; }).join(' · ')
    };
    btn.disabled = true;
    var originalLabel = btn.textContent;
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: properties }] })
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Cart error'); });
      return r.json();
    })
    .then(function () {
      btn.textContent = originalLabel;
      btn.disabled = false;
      self.toast('🍨 ' + t('addedToCart', 'Ajouté au panier'));
      return fetch('/cart.js').then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      if (cart) document.dispatchEvent(new CustomEvent('loom:cart-updated', { detail: cart }));
      self.setState({ scoops: [] });
    })
    .catch(function (err) {
      btn.textContent = originalLabel;
      btn.disabled = false;
      self.toast(err.message || t('cartError', "Erreur, réessayez."), true);
    });
  };

  LoomCupBuilder.prototype.toast = function (msg, isError) {
    if (!this.toastEl) {
      this.toastEl = document.createElement('div');
      this.toastEl.className = 'loom-toast';
      document.body.appendChild(this.toastEl);
    }
    var el = this.toastEl;
    el.textContent = msg;
    el.className = 'loom-toast' + (isError ? ' error' : '') + ' show';
    var self = this;
    if (self._toastT) clearTimeout(self._toastT);
    self._toastT = setTimeout(function () { el.className = 'loom-toast' + (isError ? ' error' : ''); }, 2400);
  };

  window.LoomCupBuilder = LoomCupBuilder;

  // iOS-safe boot — works whether DOMContentLoaded already fired or not
  function bootAll() {
    if (window._loomBooted) return;
    var nodes = document.querySelectorAll('[data-loom-cup-builder]');
    if (!nodes.length) return;
    window._loomBooted = true;
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var layout = el.getAttribute('data-layout') || 'tray';
      try { new LoomCupBuilder(el, { layout: layout }); }
      catch (e) {
        el.innerHTML = '<div style="padding:24px;text-align:center;color:#432918;font-family:monospace;font-size:11px">Cup builder erreur — ' + (e.message || e) + '</div>';
        if (window.console) console.error('LoomCupBuilder boot error', e);
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
  window.addEventListener('load', bootAll);

  document.addEventListener('loom:cart-updated', function (e) {
    var count = e.detail.item_count;
    var els = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = count;
      var wrap = els[i];
      while (wrap && wrap.className && wrap.className.indexOf('nav-cart') === -1) wrap = wrap.parentNode;
      if (wrap && wrap.className) {
        if (count === 0 && wrap.className.indexOf('is-empty') === -1) wrap.className += ' is-empty';
        else if (count !== 0) wrap.className = wrap.className.replace(' is-empty', '');
      }
    }
  });
})();
